import { Component } from '@angular/core';
import { ProductMenuHeaderComponent } from '../product-menu-header.component';

@Component({
  selector: 'app-menu-header-title',
  templateUrl: './menu-header-title.component.html',
  providers: [{ provide: ProductMenuHeaderComponent, useExisting: MenuHeaderTitleComponent }],
  standalone: false
})
export class MenuHeaderTitleComponent extends ProductMenuHeaderComponent {}
